<myre-toggle #toggle="myreToggle">
  <myre-toggle-button>
    <ng-template #rowTemplate>
      <myre-checkbox
        (ngModelChange)="updateChildren($event)"
        (click)="$event.stopPropagation()"
        [(ngModel)]="levelRow.selected"
        [indeterminate]="levelRow.indeterminate"
      />
    </ng-template>
    <ng-container
      [ngTemplateOutlet]="levelRow.template"
      [ngTemplateOutletContext]="{
        $implicit: levelRow,
        toggle: toggle,
        template: rowTemplate,
        updateCallback: updateCallback,
        first: first,
        last: last,
      }"
    />
  </myre-toggle-button>
  <myre-toggle-on>
    <div [class.with-padding-bottom]="withPaddingBottom">
      @for (
        sublevelRow of levelRow.children;
        track trackByFn($index, sublevelRow);
        let first = $first;
        let last = $last
      ) {
        @if (!sublevelRow.isLeaf) {
          <multilevel-toggle-line
            (change)="updateLevelCheckbox($event.item, $event.data)"
            [levelRow]="sublevelRow"
            [first]="first"
            [last]="last"
          />
        } @else {
          <ng-template #sublineCheckbox>
            <myre-checkbox
              checkbox
              (ngModelChange)="updateLeafLevelCheckbox(sublevelRow, $event)"
              (click)="$event.stopPropagation()"
              [(ngModel)]="sublevelRow.selected"
            />
          </ng-template>
          <ng-container
            [ngTemplateOutlet]="sublevelRow.template"
            [ngTemplateOutletContext]="{
              $implicit: sublevelRow,
              template: sublineCheckbox,
              first: first,
              last: last,
              updateCallback: updateCallback,
            }"
          />
        }
      }
    </div>
  </myre-toggle-on>
</myre-toggle>
